Vue.mixin({
  methods: {
    resetSidepanelScroll() {
      const element = document.querySelector('.sidepanel-map__content > div:first-child')
      if (element) {
        element.scrollTop = 0
      }
    }
  }
})
